import { render, staticRenderFns } from "./UserSettingsForm.vue?vue&type=template&id=66947e96"
import script from "./UserSettingsForm.vue?vue&type=script&lang=ts"
export * from "./UserSettingsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports